import * as React from 'react';

const ChevronLeft24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M15.763 6.23a.765.765 0 0 1 0 1.106L10.95 12l4.813 4.664a.765.765 0 0 1 0 1.107.826.826 0 0 1-1.142 0l-5.384-5.218a.766.766 0 0 1 0-1.106l5.384-5.218a.826.826 0 0 1 1.142 0Z"
  }
));
ChevronLeft24.Size = 24;
ChevronLeft24.Title = "ChevronLeft";

export { ChevronLeft24 as default };
